import React from 'react';
import GlobalAssumptions from '../components/GlobalAssumptions/GlobalAssumptions';
import ResultsSummary from '../components/Results/ResultsSummary';

const ResultsPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">FTE Results & Assumptions</h1>
        <p className="text-gray-600 mt-2">
          Configure workforce planning parameters and view calculated FTE requirements
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1">
          <GlobalAssumptions />
        </div>
        <div className="lg:col-span-2">
          <ResultsSummary />
        </div>
      </div>
    </div>
  );
};

export default ResultsPage;
